import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";
import { firestore } from "firebase";
import dayjs from "dayjs";

import { State } from "src/state/ducks";
import * as OrderBreadActions from "src/state/ducks/orderBread/actions";

import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import HomeButton from "src/components/atoms/button/HomeButton";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";

import { LinkButton } from "src/components/atoms/button/Button";
import Bar from "src/components/atoms/shapes/Bar";
import { OrderBreadEntity } from "src/firebase/db/OrderBreads";
import { OrderEntity } from "src/firebase/db/Orders";
import OrderList from "src/components/molecules/list/OrderList";
import ErrorMessage from "src/components/atoms/form/ErrorMessage";
type OwnProps = {
  id: string;
  date: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class OrderHistory extends Component<Props> {
  state = {
    bread: {} as OrderBreadEntity,
  };

  componentDidMount() {
    const { date, login_shop_id } = this.props;
    const startDate = dayjs(date).toDate();
    const endDate = dayjs(date).add(1, "day").toDate();
    this.props.getOrderBreads(login_shop_id, startDate, endDate);
  }

  calcBakedTime = (created_at: firestore.Timestamp, baking_minutes: number) => {
    return dayjs(created_at.toDate())
      .add(baking_minutes, "minute")
      .format("HH:mm");
  };

  formatDate() {
    const { date } = this.props;
    return dayjs(date).format("YYYY年M月D日");
  }

  _renderOrderList = () => {
    const { orderBreads } = this.props;

    // 配信データがしない
    if (!orderBreads.length) {
      return (
        <ErrorMessage fontSize={14}>{this.props.error?.message}</ErrorMessage>
      );
    }

    const calcDeliveriedAt = (orderBread: OrderBreadEntity) =>
      this.calcBakedTime(
        orderBread.created_at,
        orderBread.required_baking_minutes
      );

    const renderOrders = (orders: OrderEntity[]) => {
      // 注文データ取得時にエラーが発生した
      const { ordersError } = this.props;
      if (ordersError) {
        return (
          <ErrorMessage fontSize={14}>{ordersError?.message}</ErrorMessage>
        );
      }
      // 注文データが存在しない
      if (!orders.length) {
        return <ErrorMessage fontSize={14}>注文が存在しません。</ErrorMessage>;
      }
      return orders.map((order) => (
        <li key={order.bread_id + order.order_number}>
          <OrderList {...order} />
        </li>
      ));
    };

    const countSoldItems = (orders: OrderEntity[]) => {
      return orders.reduce((prev, acc) => {
        return prev + acc["quantity"];
      }, 0);
    };

    return orderBreads.map((orderBread, i) => (
      <div key={orderBread.id}>
        <OrderListContainer>
          <div className="bread__holder">
            <p className="bread">{orderBread.name}</p>
            <p className="send">{calcDeliveriedAt(orderBread)}配信</p>
          </div>
          <div className="total">
            <p className="total__lead">現時点総販売済数</p>
            <p className="count">
              <span>
                <span>{countSoldItems(orderBread.orders)}</span>個
              </span>
              <span>/</span>
              <span>
                <span>{orderBread.stock}</span>個
              </span>
            </p>
          </div>
          <ul className="orders">{renderOrders(orderBread.orders)}</ul>
        </OrderListContainer>
        {orderBreads.length !== i + 1 && (
          <div className="item">
            <Bar />
          </div>
        )}
      </div>
    ));
  };

  render() {
    return (
      <DefaultLayout {...this.props}>
        <SpinnerModal isLoading={this.props.isFetching} />
        <Container>
          <Heading
            tag="h1"
            text={`${this.formatDate()}の配信と注文状況を確認する`}
          />
          {this._renderOrderList()}
          <div className="item">
            <LinkButton
              isDisabled={false}
              url={`/shop/${this.props.id}/order_history`}
              text={"別の日付の配信と注文状況を確認する"}
            />
          </div>
          <div className="item">
            <HomeButton />
          </div>
        </Container>
      </DefaultLayout>
    );
  }
}

const Container = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  > .lead {
    font-size: 12px;
  }
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
`;

const OrderListContainer = styled.div`
  margin-bottom: ${StyleConfig.HELPER.M16};
  .bread {
    font-size: 20px;
    font-weight: bold;
    color: ${StyleConfig.COLOR.PRIMARY};
  }
  .send {
    font-size: 16px;
  }
  .bread__holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${StyleConfig.HELPER.M8} auto;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${StyleConfig.HELPER.M16} auto;
    .total__lead {
      font-size: 16px;
    }
    .count {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .orders {
    > li {
      margin-bottom: ${StyleConfig.HELPER.M4};
    }
  }
`;

const mapStateToProps = (state: State) => ({
  orderBreads: state.orderBread.dayOrder.resource,
  isFetching: state.orderBread.dayOrder.isFetching,
  error: state.orderBread.dayOrder.apiError,
  ordersError: state.orderBread.orders.apiError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getOrderBreads: (id: string, startDate: Date, endDate: Date) =>
    dispatch(
      OrderBreadActions.getDayOrderBreads({
        shopId: id,
        startDate: startDate,
        endDate: endDate,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);
